// MUST be the first import — disables Zod 4.x's JIT validator
// compiler before any schema-using module is imported. apps/roster
// aliases @frontend → frontend/src and pulls in hooks like
// useSessions / useStreamingChat that transitively register schemas.
// Without this line, Safari's JSC rejects the JIT-generated validator
// bodies with "Unexpected token '{'" at every parse() call. See
// frontend/src/zod-config.ts for the full rationale.
import '@frontend/zod-config'

// Side-effect import: initialises the shared i18next instance (de/fr/en)
// used by every @frontend hook and component this app reuses, and by this
// app's own `useTranslation` calls. Without it i18next is uninitialised and
// every `t()` silently falls through to its inline English default — the
// de/fr translations never appear. Mirrors apps/care-planner + apps/compatibility.
import '@frontend/i18n'

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// Design tokens FIRST — defines the --color-* custom properties that
// index.css and every `var(--color-*)` Tailwind class (neutral/primary/
// citation/surface) reference. Apps that bundle only @frontend/index.css
// inherit the shadcn HSL semantic vars but NOT the generated design tokens,
// so without this line every colour class resolves to nothing. Mirrors
// apps/care-planner's main.tsx (tokens.css → index.css order).
import '@frontend/design/tokens.css'
import '@frontend/index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
